import IndexedInstanceM from '../model/recordm.model.entity.indexedinstance.js';
import ExternalInstanceM from '../model/recordm.model.entity.externalinstance.js';
import { format } from 'date-fns'

var AutoTextJoin = function(internal, args) {
    var _fields = {};
    var _fieldNamesById = {};
    let _find;

    var _parseFieldValue = function(fieldName){

        let baseFieldName = fieldName;
        let stringify = false;
        let raw =  false;

        if(baseFieldName.endsWith('.stringify')){
            stringify = true;
            baseFieldName = baseFieldName.substring(0, baseFieldName.lastIndexOf('.stringify'))

        } else if(baseFieldName.endsWith('.raw')){
            raw = true;
            baseFieldName = baseFieldName.substring(0, baseFieldName.lastIndexOf('.raw'))
        } else {
            const formatted = (/(.*)\.format\(([^)]+)\)/).exec(fieldName);
            if (formatted) {
                const value = (_fields[formatted[1]].raw || "");

                if (value === "") return ""

                const timestamp = Number(value);
                return format(timestamp, formatted[2]);
            }
        }

        const _field = _fields[baseFieldName];
        let value = _field.value;
        if(raw) value = _field.raw;
        if(value instanceof IndexedInstanceM || value instanceof ExternalInstanceM){
            // if the source is a $*ref, we use the $instanceLabel
            value = value.getInstanceLabel();
        }

        if(stringify){
            return JSON.stringify(value);
        }

        return value;
    };

    var _join = function() {
        return args.map((arg) => _parseFieldValue(arg)).join('');
    };

    var arg2FieldName = function(arg) {
        let fieldName = arg;
        [
            /\.stringify$/g,
            /\.raw$/g,
            /\.format\([^)]+\)$/g
        ].forEach( (re) => fieldName = fieldName.replaceAll(re, ''))

        return fieldName;
    };


    return {
        init: function(instance, {find, read, onChange}) {
            _find = find;
            for (const arg of args) {

                const hardcoded = ( /'(.*)'/ ).exec(arg);
                if (hardcoded) {
                    _fields[arg] = { value: hardcoded[1], raw: hardcoded[1]};

                    // There is no need to subscribe for value change
                    // because a constant never changes
                    /* eslint-disable-next-line no-continue  */
                    continue;
                }

                if (arg.toLowerCase() === 'id') {
                    _fields[arg] = { value: instance.id, raw: instance.id};

                    // There is no need to subscribe for value change
                    // because the id never changes
                    /* eslint-disable-next-line no-continue  */
                    continue;
                }

                var fieldName = arg2FieldName(arg);
                var target = find(fieldName);
                var targetValues = read(target);

                _fields[fieldName] = { value: targetValues.value, raw: targetValues.rawValue };
                _fieldNamesById[target.id] = fieldName;

                internal.subscribe('field-value-change-byDef-' + target.defId, onChange );
            }
        },
        setArgs: function(fieldId, value, rawValue) {
            const fieldName = _fieldNamesById[fieldId];
            const upToDateField = _find(fieldName);
            if(upToDateField.id != fieldId){
                _fieldNamesById[upToDateField.id] = fieldName;
            }
            _fields[fieldName] = { value: value, raw: rawValue };
        },
        apply: function() {
           return { value: _join(_fields) };
        }
    }
};

export { AutoTextJoin };
